export const iconFontAwesomeEditingCheckDouble = (
	<i className="fa-solid fa-check-double"></i>
);
